import React, {useEffect} from 'react';
import './events.scss'
import {Footer, Navigation} from "../../components";
import EventsHero from './sections/event-hero/EventsHero';
import EventsList from "./sections/events-list/EventsList";

const Events = () => {
    useEffect(() => {
        window.scrollTo(0, 0);

    }, []);
    return (
        <div className={'events-page'}>
            <div className="events-page_nav">
                <Navigation/>
            </div>
            <EventsHero/>
            <EventsList/>
            <Footer/>
        </div>
    );
};

export default Events;
